import { createSlice } from '@reduxjs/toolkit';

export const toastSlice = createSlice({
    name: 'toast',
    initialState: false,
    reducers: {
        setIsShowToast: (state, action) => action.payload,
    },
});

export const { setIsShowToast } = toastSlice.actions;

export default toastSlice.reducer;
